export default __webpack_public_path__ + "static/media/header-iphone.3a534c5f.png";